var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    {
      dark: _vm.dark && _vm.$vuetify.theme.dark,
      light: !_vm.dark || !_vm.$vuetify.theme.dark
    },
    _vm.category.toLowerCase()
  ]},[_c('div',{ref:"sr-widget",staticClass:"sr-widget sr-widget-1"})])
}
var staticRenderFns = []

export { render, staticRenderFns }